import { SyntheticEvent, useCallback } from 'react';

import { FileTextIcon, XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { preventClickThrough } from '@/util/util';

interface Props {
  fileName: string;
  fileType: string;
  handleClose?: (e?: SyntheticEvent) => void;
}

const UploadCard = ({ fileName, fileType, handleClose }: Props) => {
  const { t } = useTranslation();

  const handleCloseButton = useCallback(
    (e) => {
      preventClickThrough(e);
      handleClose(e);
    },
    [handleClose]
  );

  return (
    <>
      <div className="group relative mx-0 mr-2 mb-2 flex h-12 w-49.25 items-center gap-2 rounded border border-border bg-background py-1.5 pr-8 pl-1.5 shadow-sm transition-colors duration-150">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded bg-selected-soft">
          <FileTextIcon size={20} className="text-muted-foreground" />
        </div>

        <div className="flex min-w-0 flex-col overflow-hidden select-none">
          <InfoTooltip content={fileName} delayDuration={600}>
            <span className="truncate text-sm leading-5 font-medium text-muted-foreground">
              {fileName}
            </span>
          </InfoTooltip>
          <span className="text-sm leading-5 font-normal text-muted-foreground uppercase">
            {fileType}
          </span>
        </div>

        <InfoTooltip content={t('common.remove')} showArrow>
          <XIcon
            size={16}
            className="absolute -top-2 -right-2 hidden cursor-pointer rounded-full bg-muted-foreground p-0.5 text-background group-hover:inline hover:bg-muted-foreground"
            onClick={handleCloseButton}
            onKeyDown={handleCloseButton}
          />
        </InfoTooltip>
      </div>
    </>
  );
};

export default UploadCard;
